// security roles defined in Azure AD

export const SUPER_ADMIN_ROLE = 'super_admin';
export const ADMIN_ROLE = 'administrator';
export const SUPPORT_ROLE = 'support';
export const SALES_OPS_ROLE = 'sales';
export const COMMUNITY_ROLE = 'community';
export const COMMUNITY_MANAGER_ROLE = 'community_manager';
